import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getUserBrief } from '../api/user';
import type { ReactionSummaryDto, UserBriefDto } from '../api/types';
import Avatar from './Avatar';
import Emoji from './Emoji';
import { backdropClose } from '../lib/modalBackdrop';

interface Props {
  reactions: ReactionSummaryDto[];
  meId?: string;
  onClose: () => void;
}

/** Кто поставил реакцию — по эмодзи, с именами (запрашиваются лениво, только при открытии). */
export default function ReactionListModal({ reactions, meId, onClose }: Props) {
  const { t } = useTranslation('misc');
  const [users, setUsers] = useState<Map<string, UserBriefDto>>(new Map());

  useEffect(() => {
    const ids = new Set<string>();
    for (const r of reactions) for (const id of r.userIds) ids.add(id);
    for (const id of ids) {
      if (id === meId) continue;
      getUserBrief(id)
        .then((u) => setUsers((prev) => new Map(prev).set(id, u)))
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const nameOf = (id: string) => (id === meId ? t('reactionListSelf') : users.get(id)?.displayName || '…');

  return (
    <div className="modal-backdrop" {...backdropClose(onClose)}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 340 }}>
        <h2>{t('reactionListTitle')}</h2>
        <button type="button" className="modal-close" title={t('reactionListClose')} onClick={onClose}>✕</button>
        <div className="reaction-list">
          {reactions.map((r) => (
            <div key={r.emoji} className="reaction-list-group">
              <div className="reaction-list-emoji"><Emoji char={r.emoji} /></div>
              <div className="reaction-list-names">
                {r.userIds.map((id) => (
                  <div key={id} className="reaction-list-row">
                    <Avatar userId={id} name={nameOf(id)} size={28} />
                    <span>{nameOf(id)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
